/* German UI labels for Judge.me in this theme; customer review text stays untouched. */
(() => {
  if (!/^de(?:-|$)/i.test(document.documentElement.lang)) return;
  const rootSelector = '.jdgm-widget';
  const observed = new WeakSet();
  const number = value => Number(value).toLocaleString('de-DE');
  const fixedLabels = {
    'Customer reviews': 'Kundenbewertungen',
    'Previous slide': 'Vorherige Bewertung',
    'Next slide': 'Nächste Bewertung'
  };
  const translateLabel = label => {
    if (fixedLabels[label]) return fixedLabels[label];
    let match = label.match(/^(?:Average rating is )?(\d+(?:\.\d+)?)(?: out of 5)? stars$/);
    if (match) return Number(match[1]) === 0 ? 'Noch keine Bewertungen' : `${number(match[1])} von 5 Sternen`;
    match = label.match(/^(\d+(?:\.\d+)?)% \((\d+)\) reviews with (\d) star rating$/);
    if (match) return `${match[3]} ${match[3] === '1' ? 'Stern' : 'Sterne'}: ${number(match[2])} ${Number(match[2]) === 1 ? 'Bewertung' : 'Bewertungen'} (${number(match[1])} %)`;
    return label;
  };
  function localize(root) {
    [root, ...root.querySelectorAll('[aria-label], [alt]')].forEach(element => {
      ['aria-label', 'alt'].forEach(attribute => {
        const original = element.getAttribute(attribute);
        if (!original) return;
        const translated = translateLabel(original);
        if (original !== translated) element.setAttribute(attribute, translated);
      });
    });
    root.querySelectorAll('.jdgm-rev-widg__summary-text').forEach(element => {
      if (['Schreiben Sie die erste Bewertung', 'Be the first to write a review'].includes(element.textContent.trim())) {
        element.textContent = 'Noch keine Bewertungen';
      }
    });
    root.querySelectorAll('.jdgm-write-rev-link').forEach(element => {
      if (['Write a review', 'Schreiben Sie eine Bewertung'].includes(element.textContent.trim())) {
        element.textContent = 'Bewertung schreiben';
      }
    });
    root.querySelectorAll('.jdgm-sort-dropdown').forEach(element => {
      if (element.getAttribute('aria-label') !== 'Bewertungen sortieren') element.setAttribute('aria-label', 'Bewertungen sortieren');
    });
    root.querySelectorAll('.jdgm-sort-dropdown-wrapper').forEach(element => {
      element.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === 'Sort by') node.textContent = 'Sortieren nach ';
      });
    });
  }
  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    localize(root);
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; localize(root); });
    }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt'] });
  }
  // App widgets may arrive after the page, including theme-editor section reloads.
  document.querySelectorAll(rootSelector).forEach(observe);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches(rootSelector)) observe(node);
      node.querySelectorAll(rootSelector).forEach(observe);
    }));
  }).observe(document.body, { childList: true, subtree: true });
})();
